module.exports = __webpack_public_path__ + "files/71485417391d9b3e6ba89aeb45ae07ce.png";